import { Root } from '@atlassian/navigation-system/v4';
import React from 'react';
import { useRouter } from 'react-resource-router';

import { BetterUpdatesChangeboarding } from '@townsquare/onboarding/better-updates';
import { IntroPopup } from '@townsquare/onboarding/intro-popup';
import { HomepageRoute } from '@townsquare/router/route-types';
import { SiteBannerProvider } from '@townsquare/site-banner';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { GriffinSidebarNavigation } from '../griffin-navigation/GriffinSidebarNavigation';
import { GriffinTopNavigation } from '../griffin-navigation/GriffinTopNavigation';
import { GriffinLayout } from '../layouts/Home/GriffinLayout';

export function GriffinRoute() {
  const noWorkspaceExperience = useNoWorkspaceExperience();
  const [routerState] = useRouter();
  const route = routerState.route as HomepageRoute;
  const layout = route?.layout || 'home';
  // Side nav is disabled in full screen mode
  const shouldRenderSideNav = layout !== 'full-screen';

  return (
    <>
      <SiteBannerProvider>
        <Root>
          <GriffinTopNavigation />
          {shouldRenderSideNav && <GriffinSidebarNavigation />}
          <GriffinLayout layout={layout} aside={route?.aside} navigation={route?.navigation} />
          {noWorkspaceExperience && <IntroPopup />}
        </Root>
      </SiteBannerProvider>
      <BetterUpdatesChangeboarding />
    </>
  );
}
